import { panelTitleVariants } from "@/components/atoms/panelTitle";
import { typographyTextVariants } from "@/components/atoms/typographyText";
import { cn } from "@/lib/utils";

export const CONSOLE_DIALOG_TITLE_CLASS = cn(panelTitleVariants(), "mb-0");

export const CONSOLE_DIALOG_BODY_CLASS = cn(
  typographyTextVariants({ variant: "body" }),
  "mt-0",
);
